function Kvp({ k, v }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:gap-3 py-1">
      <div className="w-full sm:w-60 text-neutral-400 text-sm uppercase tracking-wide">{k}</div>
      <div className="flex-1">{v}</div>
    </div>
  );
}

export default function Privacy() {
  const meta = {
    operator: "TA TECH HUB SRL",
    registration: "J40/9943/2024, CUI 50099092",
    address: "Aleea Compozitorilor, Nr. 2, Bloc Z38, Scara 1, Etaj 2, Ap 14, București, România",
    emails: ["theodorz@2getters.com", "adinap@2getters.com"],
    lastUpdate: "2025-10-04",
    tocTitle: "Contents",
  };

  const toc = [
    { id: "technical-information", title: "Technical Information" },
    { id: "cookies", title: "Cookies" },
    { id: "external-links", title: "External Links" },
    { id: "contact-information", title: "Contact Information" },
  ];

  return (
    <section className="max-w-6xl mx-auto px-4 py-12 space-y-10">
      <header className="rounded-2xl border border-neutral-800 bg-white/5 backdrop-blur-sm p-6 md:p-8">
        <h1 className="text-4xl md:text-5xl font-extrabold">Privacy Policy</h1>
        <p className="text-neutral-300 mt-3 md:text-lg">
          How we handle technical logs, cookies, external links, and how you can reach us.
        </p>

        <div className="mt-6 grid sm:grid-cols-2 gap-4 text-sm">
          <Kvp k="Controller" v={meta.operator} />
          <Kvp
            k="Website"
            v={
              <a
                className="underline"
                href="https://www.2getters.com"
                target="_blank"
                rel="noreferrer"
              >
                www.2getters.com
              </a>
            }
          />
          <Kvp k="Registration" v={meta.registration || "—"} />
          <Kvp k="Address" v={meta.address} />
          <Kvp
            k="Contact E-mail"
            v={
              <div className="space-y-1">
                {meta.emails.map((e) => (
                  <div key={e}>
                    <a className="underline" href={`mailto:${e}`}>
                      {e}
                    </a>
                  </div>
                ))}
              </div>
            }
          />
          <Kvp k="Last update" v={meta.lastUpdate} />
        </div>
      </header>

      <nav className="rounded-2xl border border-neutral-800 p-6">
        <h2 className="text-xl font-bold mb-3">{meta.tocTitle}</h2>
        <ol className="grid sm:grid-cols-2 gap-x-6 gap-y-2 text-neutral-300">
          {toc.map((item) => (
            <li key={item.id}>
              <a className="underline hover:text-white" href={`#${item.id}`}>
                {item.title}
              </a>
            </li>
          ))}
        </ol>
      </nav>

      <section
        id="technical-information"
        className="rounded-2xl border border-neutral-800 p-6 space-y-3 scroll-mt-24"
      >
        <h2 className="text-2xl md:text-3xl font-extrabold">Technical Information</h2>
        <p className="text-neutral-300">
          This website automatically collects minimal technical information when you visit, including your IP
          address, browser type, operating system, and the date and time of access.
        </p>
        <p className="text-neutral-300">
          These data are collected exclusively for security, performance, and site maintenance purposes.
        </p>
        <p className="text-neutral-300">
          The data are processed by the site operator <strong>2Getters</strong> and by <strong>Cloudflare</strong>,
          a third-party service provider acting as a data processor.
        </p>
        <p className="text-neutral-300">
          Access to this information is strictly limited to authorized personnel, and the data are not used for
          marketing, profiling, or identifying individual visitors.
        </p>
        <p className="text-neutral-300">
          All data are handled in accordance with the General Data Protection Regulation (GDPR).
        </p>
      </section>

      <section id="cookies" className="rounded-2xl border border-neutral-800 p-6 space-y-3 scroll-mt-24">
        <h2 className="text-2xl md:text-3xl font-extrabold">Cookies</h2>
        <p className="text-neutral-300">
          The website does not use marketing or analytics cookies (e.g., Google Analytics, Facebook Pixel). Only
          cookies strictly necessary for the technical functioning of the site may be used.
        </p>
      </section>

      <section
        id="external-links"
        className="rounded-2xl border border-neutral-800 p-6 space-y-3 scroll-mt-24"
      >
        <h2 className="text-2xl md:text-3xl font-extrabold">External Links</h2>
        <p className="text-neutral-300">
          The site may contain links to external pages (e.g., LinkedIn, Facebook). We do not assume responsibility
          for the content or policies of these external websites.
        </p>
      </section>

      <section
        id="contact-information"
        className="rounded-2xl border border-neutral-800 p-6 space-y-3 scroll-mt-24"
      >
        <h2 className="text-2xl md:text-3xl font-extrabold">Contact Information</h2>
        <p className="text-neutral-300">
          If you want to contact us, you can do so using the details provided on the site (email, phone). Any
          communication takes place directly and is not recorded on this website.
        </p>
      </section>
    </section>
  );
}
